export default __webpack_public_path__ + "bae4319da8a07242596ad0ce89500783.png";